import { Paper, Typography, Box } from "@mui/material";

function SectionInfoPanel({ section }: any) {
  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
      {/* Row 1: Title + Image */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="h6" fontWeight="bold">
          {section.name}
        </Typography>
        {section.image && (
          <Box
            component="img"
            src={section.image?.url}
            alt={section.name}
            sx={{
              height: 50,
              width: 50,
              objectFit: "cover",
              borderRadius: 1,
              ml: 2,
            }}
          />
        )}
      </Box>

      {/* Row 2: Intro */}
      <Typography variant="body2" color="text.secondary">
        {section.intro ?? ""}
      </Typography>
    </Paper>
  );
}

export default SectionInfoPanel;
